import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const FullscreenIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-labelledby="titleId"
      aria-label="fullscreen icon"
      {...props}
    >
      <path
        d="M21.0838 15.4141V17.9253C21.0838 19.6231 19.707 20.9998 18.0083 20.9998H15.498"
        stroke={props.fill || "currentColor" || "#202123"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.08398 15.4141V17.9253C3.08398 19.6231 4.46072 20.9998 6.15951 20.9998H8.66974"
        stroke={props.fill || "currentColor" || "#202123"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.08398 8.58673V6.07552C3.08398 4.37674 4.46072 3 6.15951 3H8.66974"
        stroke={props.fill || "currentColor" || "#202123"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0838 8.58673V6.07552C21.0838 4.37674 19.7071 3 18.0083 3H15.498"
        stroke={props.fill || "currentColor" || "#202123"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FullscreenIcon;
